import request from '@/utils/request'

// http://192.168.1.201:65/adminapi/stamp/personal/seal_list
export function seal_list (data) {
    return request({
        url: '/stamp/personal/seal_list',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:65/adminapi/team/get_user_teamlist?page=1&limit=20
// 团队列表
export function get_user_teamlist (data) {
    return request({
        url: '/team/get_user_teamlist',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:65/adminapi/team/get_details?team_id=2
// 团队详情
export function get_details (data) {
    return request({
        url: '/team/get_details',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:65/adminapi/team/get_member_list?team_id=1&limit=20&page=1
// 获取成员列表
export function get_member_list (data) {
    return request({
        url: '/team/get_member_list',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:65/adminapi/team/add_user
// 添加成员
export function add_user (data) {
    return request({
        url: '/team/add_user',
        method: 'post',
        data: data
    })
}
// http://192.168.1.201:65/adminapi/team/up_name
// 修改团队名称
export function up_name (data) {
    return request({
        url: '/team/up_name',
        method: 'post',
        data: data
    })
}
// http://192.168.1.201:65/adminapi/team/up_member_name
// 修改成员名称
export function up_member_name (data) {
    return request({
        url: '/team/up_member_name',
        method: 'post',
        data: data
    })
} 
// http://192.168.1.201:65/adminapi/templates/get_signing_link?contract_id=176
// 获取签署链接
export function get_signing_link (data) {
    return request({
        url: '/templates/get_signing_link',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:65/adminapi/team/get_setmeal_list?type=1&page=&limit=
// 获取套餐列表
export function get_setmeal_list (data) {
    return request({
        url: '/team/get_setmeal_list',
        method: 'get',
        params: data
    })
}

// http://192.168.1.201:65/adminapi/team/edit_setmenu
export function edit_setmenu (data) {
    return request({
        url: '/team/edit_setmenu',
        method: 'post',
        data: data
    })
}
// http://192.168.1.201:65/adminapi/team/del_setmenu
export function del_setmenu (data) {
    return request({
        url: '/team/del_setmenu',
        method: 'post',
        data: data
    })
}
// http://192.168.1.201:65/adminapi/team/get_order_list?type=1&page=1&limit=20
// 获取订单列表
export function get_order_list (data) {
    return request({
        url: '/team/get_order_list',
        method: 'get',
        params: data
    })
}
// http://192.168.0.201:65/adminapi/team/up_apply_refund
// 申请退款
export function up_apply_refund (data) {
    return request({
        url: '/team/up_apply_refund',
        method: 'post',
        data: data
    })
}